import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { DateRangePickerComponent } from './date-range-picker.component'
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { ConfigModule, I18nModule } from '@spartacus/core'
import { environment } from '../../../../environments/environment'

@NgModule({
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['sharedComponents'],
        },
      },
    }),
  ],
  declarations: [DateRangePickerComponent],
  exports: [DateRangePickerComponent],
})
export class DateRangePickerModule {}
